import { gql } from '@apollo/client';

export const CREATE_GROUP = gql`
  mutation CreateGroup($input: CreateGroupRequest!) {
    createGroup(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const UPDATE_GROUP = gql`
  mutation UpdateGroup($input: UpdateGroupRequest!) {
    updateGroup(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const SOFT_DELETE_GROUP = gql`
  mutation SoftDeleteGroup($input: SoftDeleteGroupRequest!) {
    softDeleteGroup(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;
